// extracted by mini-css-extract-plugin
module.exports = {"PhotoInput":"PhotoInput_PhotoInput__jc2U0","DivInput":"PhotoInput_DivInput__186KB","ToolTipPhoto":"PhotoInput_ToolTipPhoto__3hQmq"};